<script lang="ts">
	import type { HTMLAttributes } from "svelte/elements";
	import Formatted from "./common/Formatted.svelte";

	const all: Omit<HTMLAttributes<HTMLDivElement>, "children"> = $props();
</script>

<div {...all} class={["text-center text-2xs/none md:text-sm/tight", all.class]}>
	<Formatted
		text="Tato stránka je chráněna službou reCAPTCHA a uplatňují se [https://policies.google.com/privacy][[Zásady ochrany soukromí]] a [https://policies.google.com/terms][[Smluvní podmínky]] společnosti Google."
	/>
</div>
